var render, staticRenderFns
import script from "./DraggableItem_workMan2.vue?vue&type=script&lang=js"
export * from "./DraggableItem_workMan2.vue?vue&type=script&lang=js"
import style0 from "./DraggableItem_workMan2.vue?vue&type=style&index=0&id=491dc6c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491dc6c1",
  null
  
)

export default component.exports